import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DialogProps } from "@mui/material";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectAgentUid } from "../../redux/selectors";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { AppNewInput } from "../../../../shared/components/AppNewInput";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  handleApprovedTgBot: (uid: string, code: string) => void;
  closeModal: (id: TModalsIds) => void;
}

export const ApprovedTgBotModal = ({
  closeModal,
  handleApprovedTgBot,
}: Props) => {
  const approvedTgBot = useModalSelectors("approved_tg_bot_modal");
  const uid = useAppSelector(selectAgentUid);
  const [code, setCode] = useState<string>("");
  const { t } = useTranslation();

  const handleCloseModal = () => {
    closeModal("approved_tg_bot_modal");
  };

  const handleChangeCode = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setCode(event.target.value);
  };

  return (
    <ModalBasic
      open={approvedTgBot.isOpen}
      title={"Подтверждение подключение"}
      hasCloseButton
      closeModal={handleCloseModal}
      onClose={handleCloseModal}
      hasFooter
      buttonOkText={t("common.confirm_button")}
      onOk={() => {
        handleApprovedTgBot(uid, code);
        closeModal("create_agent_modal");
      }}
      onCancel={handleCloseModal}
      disabledOkBtn={code === ""}
      className={styles["modal"]}
    >
      <div className={styles.container}>
        <div className={styles["input-container"]}>
          <AppLabel>Код подтверждения</AppLabel>
          <AppNewInput
            value={code}
            className={styles.input}
            onChange={handleChangeCode}
          />
        </div>
      </div>
    </ModalBasic>
  );
};
